import { Text, Tooltip } from "@chakra-ui/react";
import { makeHTMLSafe } from "@src/utils/security/makeHTMLSafe";
import { formatDistanceToNow } from "date-fns";
import { observer } from "mobx-react-lite";

interface MessageProps {
  message: string;
  createdAt?: Date;
}

const Message = ({ message, createdAt }: MessageProps) => {
  const safeMessage = makeHTMLSafe(message);
  const strippedMessage = safeMessage
    .replaceAll("<strong>", "")
    .replaceAll("</strong>", "");
  const shouldHideTooltip = strippedMessage.length <= 70;

  return (
    <div className="flex flex-col min-w-0 px-5">
      <Tooltip
        isDisabled={shouldHideTooltip}
        label={<Text>{strippedMessage}</Text>}
      >
        <p className="text-xl">{strippedMessage}</p>
      </Tooltip>
      <p className="text-inkLighter text-lg">
        {createdAt
          ? formatDistanceToNow(createdAt, { addSuffix: true })
          : undefined}
      </p>
    </div>
  );
};

export default observer(Message);
